var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "cw-toolbar-containers",
    },
    [
      _c(
        "div",
        {
          staticClass: "cw-container-style-selector",
          attrs: {
            role: "group",
            "aria-labelledby": "cw-containeradder-style",
          },
        },
        [
          _c(
            "p",
            {
              staticClass: "sr-only",
              attrs: {
                id: "cw-containeradder-style",
              },
            },
            [_vm._v(_vm._s(_vm.$gettext("Abschnitt-Stil")))]
          ),
          _vm._v(" "),
          _vm._l(_vm.containerStyles, function (style) {
            return [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.selectedContainerStyle,
                    expression: "selectedContainerStyle",
                  },
                ],
                key: style.key + "-input",
                attrs: {
                  type: "radio",
                  name: "container-style",
                  id: "style-" + style.colspan,
                },
                domProps: {
                  value: style.colspan,
                  checked: _vm._q(_vm.selectedContainerStyle, style.colspan),
                },
                on: {
                  change: function change($event) {
                    _vm.selectedContainerStyle = style.colspan
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "label",
                {
                  key: style.key + "-label",
                  class: [
                    _vm.selectedContainerStyle === style.colspan
                      ? "cw-container-style-selector-active"
                      : "",
                    style.colspan,
                  ],
                  attrs: {
                    for: "style-" + style.colspan,
                  },
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(style.title) +
                      "\n            "
                  ),
                ]
              ),
            ]
          }),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "draggable",
        {
          ref: "containerSortables",
          staticClass: "cw-containeradder-items",
          attrs: {
            tag: "ul",
            role: "listbox",
            handle: ".cw-sortable-handle-containeradder",
            group: {
              name: "description",
              pull: "clone",
              put: "false",
            },
            clone: _vm.cloneContainer,
            sort: false,
            emptyInsertThreshold: 20,
          },
          on: {
            start: function start($event) {
              return _vm.dragContainerStart($event)
            },
            end: function end($event) {
              return _vm.dropNewContainer($event)
            },
          },
          model: {
            value: _vm.containerTypes,
            callback: function callback($$v) {
              _vm.containerTypes = $$v
            },
            expression: "containerTypes",
          },
        },
        _vm._l(_vm.containerTypes, function (container) {
          return _c("courseware-container-adder-item", {
            key: container.type,
            attrs: {
              title: container.title,
              type: container.type,
              colspan: _vm.selectedContainerStyle,
              description: container.description,
              firstSection: _vm.firstSection,
              secondSection: _vm.secondSection,
              newPosition: _vm.newContainerPosition,
            },
          })
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }